
import { User } from "@/models";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "SignUpSetInfo",
created() {
this.from = this.$route.query.from;
this.phone = this.$route.query.phone;
},
props: [],
data() {
return {
from: "",
phone: "",
password: "",
username: ""
};
},
methods: {
signUp: function() {
if (this.username == "") {
this.$vux.toast.text("用户名不能为空", "middle");
return;
}

if (this.password == "") {
this.$vux.toast.text("验证码不能为空", "middle");
return;
}

User.getNonRepetitiveUsername(this.username).then(username => {
User.setInfo(username, this.password)
.then(user => {
this.$router.push({ path: this.from || "/" });
})
.catch(() => {
this.$vux.toast.text("注册失败，请稍后再试", "middle");
});
});
}
},
components: {
XInput,
Group,
XButton
}
};



// WEBPACK FOOTER //
// ./src/pages/account/SignUpSetInfo.vue